import React, { Component } from "react";

import { Input } from "antd";
import dateFormat from "dateformat";
import MedicineTable from "./MedicineTable";
import Paper from "@material-ui/core/Paper";
import "./MedicineMaster.css";
import { withTranslation } from 'react-i18next';
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import Grid from "@material-ui/core/Grid";
import Labelbox from "../../helpers/labelbox/labelbox";
import Button from "@material-ui/core/Button";
import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import { Label } from "reactstrap";

class MedicineMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: false,
      openPasswordModal: false,
      userName: "",
      password: ""
    };
  }
  componentDidMount() {
    this.setState({ openPasswordModal: false });
  }
  closemodal = () => {
    this.setState({ view: false });
  };
  handleClickOpen = (t, title) => {
    this.setState({ view: true });
  };

  closePasswordModal(event) {
    this.props.history.push("/Home/dashboard");
  }

  changeDynamic(data, type) {
    if (type == "userName") {
      this.setState({ userName: data });
    } else {
      this.setState({ password: data });
    }
  }

  loginMedicine() {
    if (this.state.userName != "" && this.state.password != "") {
      this.setState({
        view: true,
        error_msg: "",
      });
      axiosInstance({
        method: "POST",
        url: apiurl + "pharmacy/medicineAddUserCheck",
        data: {
          userName: this.state.userName,
          password: this.state.password
        }
      })
        .then((response) => {
          if (response.data.data[0].status == 1) {
            this.setState({ openPasswordModal: false });
          } else {
            alert(response.data.data[0].msg);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      if (this.state.userName == "" && this.state.password == "") {
        this.setState({
          view: true,
          error_msg: "Field Required",
        });
      } else if (this.state.userName == "") {
        this.setState({ view: true, error_msg: "Field Required" });
      } else if (this.state.password == "") {
        this.setState({
          view: true,
          error_msg: "Field Required",
        });
      }
    }
  }

  render() {
    console.log(this.state.value)
    const { t } = this.props;
    console.log(dateFormat(new Date(), "dd-mmm-yy"));
    return (
      <div>
        {this.state.openPasswordModal == false && (
          <div className="doctor_revenue">
            <Paper>
              <MedicineTable t={t} i18n={this.props.i18n} isfromverification={this.props.isfromverification}
                backVerification={this.props.backVerification} />
            </Paper>
          </div>
        )}
        {this.state.openPasswordModal == true && (
          <div>
            <Modalcomp
              visible={this.state.openPasswordModal}
              clrchange="text_clr_change" title={t("manage_medicine_acess")}
              closemodal={(e) => this.closePasswordModal()}
              modelwidthClass="medicineUserModal"
            >
              <Grid item md={12} sm={12}>
                <Labelbox
                  type="text"
                  labelname={t("medicine_userName")}
                  changeData={(data) => this.changeDynamic(data, "userName")}
                  value={this.state.userName}
                  //error={this.state.ProfileEditData.Email.error}
                  errmsg={this.state.error_msg}
                  inputDesign="borderBottomInput"
                  inputLabel="inputLabel"
                  required
                  showIcon
                  placeholder={t("enter_user_name")}
                />
                <div className="error-msg"
                  style={{
                    display: this.state.userName == "" ? "block" : "none",
                    color: "#ff0068",
                  }}
                >
                  <label>{this.state.userName == "" ? <>{this.state.error_msg}</> : ""}</label>
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <Labelbox
                  type="text"
                  labelname={t('medicine_password')}
                  changeData={(data) => this.changeDynamic(data, "password")}
                  value={this.state.password}
                  //error={this.state.remark_error}
                  errmsg={"Please enter remark"}
                  inputDesign="borderBottomInput1"
                  inputLabel="inputLabel"
                  required
                  showIcon
                  placeholder={t("enter_password")}
                />
                <div className="error-msg-password"
                  style={{
                    display: this.state.password == "" ? "block" : "none",
                    color: "#ff0068",
                  }}
                >
                  <label>{this.state.password == "" ? <>{this.state.error_msg}</> : ""}</label>
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className="note_content">
                  {/* <label style={{fontFamily: 'Titillium Web'}}>{t("Note")}</label> */}
                </div>
              </Grid>
              {/* <div
                style={{
                  display: this.state.view ? "block" : "none",
                  color: "#ff0068",
                  textAlign: "center",
                  marginTop: "5px",
                }}
              >
                {this.state.error_msg}
              </div> */}
              <div className="buttonCenter all_details">
                <div>
                  <div>
                    <Button
                      className="update_button"
                      variant="contained"
                      color="primary"
                      onClick={() => { this.loginMedicine() }}
                    >
                      {t('login')}
                    </Button>
                  </div>
                </div>
              </div>
            </Modalcomp>
          </div>
        )}
      </div>
    );
  }
}
export default withTranslation()(MedicineMaster);
